import n from "./_baseHasIn.js";
import t from "./_hasPath.js";
function f(a, r) {
  return a != null && t(a, r, n);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/hasIn.js
// module id = 1518
// module chunks = 41